export const COMPANY = {
  name: "TechAI Fortune",
  legal: "TECHAIFORTUNE Inc.",
  tagline: "IT Consulting & Staffing",
  email: "info@techaifortuneinc.com",
  address: ["17350 State Highway 249, Suite 220, #36665", "Houston, TX 77064, United States"],
  eyebrow: "Premium U.S. IT Services • Technology Consulting • AI • Cloud • Cybersecurity • Software Development • Digital Transformation",
  positioning: "AI • Technology • People • Business Growth",
};

export const PROCESS = [
  { n: "01", title: "Discover", desc: "Understand business objectives, users, systems and constraints." },
  { n: "02", title: "Strategy", desc: "Define priorities, architecture, roadmap and success criteria." },
  { n: "03", title: "Design", desc: "Design user experience, technical solution and operating model." },
  { n: "04", title: "Build", desc: "Develop, integrate and test." },
  { n: "05", title: "Deploy", desc: "Release safely with documentation and monitoring." },
  { n: "06", title: "Optimize", desc: "Measure, improve and support continuous outcomes." },
];

export const TRANSFORMATION_STORY = [
  { key: "data", title: "Data", desc: "Unify fragmented sources into trusted foundations." },
  { key: "processing", title: "Processing", desc: "Pipelines and platforms that scale with the business." },
  { key: "intelligence", title: "Intelligence", desc: "Models and analytics that surface what matters." },
  { key: "decision", title: "Decision", desc: "Automation and copilots that act with human oversight." },
  { key: "outcome", title: "Business Outcome", desc: "Measurable growth, efficiency and resilience." },
];

export const WHY_US = [
  { title: "Business-first technology approach", desc: "Every engagement starts with the business problem, not the tool." },
  { title: "Integrated consulting and delivery", desc: "The team that designs the strategy also ships the solution." },
  { title: "Scalable engineering capabilities", desc: "Architecture, platforms and delivery models built to grow." },
  { title: "Workforce and staffing support", desc: "The right people alongside the right technology." },
  { title: "Outcome-oriented engagement model", desc: "Success criteria defined up front and measured throughout." },
];

export const TRUST_CATEGORIES = [
  "Cloud Platforms", "AI & ML Frameworks", "Data Platforms", "Automation & RPA", "DevOps & Observability", "Cybersecurity", "Enterprise Software", "Workforce Systems",
];

export const ECOSYSTEM = [
  { title: "Cloud", items: ["Architecture", "Migration", "Kubernetes", "Serverless"] },
  { title: "AI & ML", items: ["LLMs", "RAG", "Computer Vision", "MLOps"] },
  { title: "Data", items: ["Warehousing", "Lakehouse", "Streaming", "BI"] },
  { title: "Automation", items: ["RPA", "AI Agents", "Workflow", "Document AI"] },
  { title: "Software", items: ["Web", "Mobile", "APIs", "SaaS"] },
  { title: "Security", items: ["Identity", "Cloud Security", "Compliance", "Monitoring"] },
];

export const SERVICE_LINES = [
  { title: "Recruitment Staffing", verticals: ["Office & Admin", "Healthcare", "Technology", "Finance"] },
  { title: "Temporary Staffing", verticals: ["Office & Admin", "Healthcare", "Manufacturing", "Technology"] },
  { title: "Contract & Project Staffing", verticals: ["Technology", "Engineering", "Professional Services"] },
  { title: "Direct Hire Placement", verticals: ["Technology", "Healthcare", "Office & Admin", "Finance"] },
  { title: "Executive & Leadership Search", verticals: ["Technology", "Professional Services", "Operations"] },
  { title: "Managed Workforce Solutions", verticals: ["Healthcare", "Manufacturing", "Technology", "Office & Admin"] },
];

export const VERTICAL_SLUG = {
  "Office & Admin": "office-administration",
  Healthcare: "healthcare-staffing",
  Manufacturing: "manufacturing-staffing",
  Technology: "technology-staffing",
  Finance: "financial-services",
  "Professional Services": "professional-services",
  Engineering: "technology-staffing",
  Operations: "professional-services",
};

export const FORM_OPTIONS = {
  services: ["AI & ML", "Generative AI", "Data Engineering", "AI Automation", "Cloud & AI Infrastructure", "Custom Software", "Workforce Solutions", "Not sure yet"],
  industries: ["Office Administration", "Healthcare", "Manufacturing", "Technology", "Financial Services", "Professional Services", "Other"],
  projectTypes: ["Advisory", "Implementation", "Migration", "Managed Services", "Staffing"],
  budgets: ["Under $25k", "$25k – $100k", "$100k – $500k", "$500k+", "Prefer not to say"],
  timelines: ["Immediately", "Within 1 month", "1 – 3 months", "3 – 6 months", "Exploring"],
  staffingTypes: ["Temporary", "Contract", "Contract-to-Hire", "Direct Hire", "Executive Search", "Managed Workforce"],
  workModes: ["On-site", "Hybrid", "Remote"],
  experience: ["0 – 2 years", "3 – 5 years", "6 – 10 years", "10+ years"],
  availability: ["Immediately", "2 weeks", "1 month", "Flexible"],
};
